"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWishlistQueryResult = void 0;
class GetWishlistQueryResult {
    constructor(wishlist) {
        this.wishlist = wishlist;
    }
}
exports.GetWishlistQueryResult = GetWishlistQueryResult;
